(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collapsible-icon-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collapsible]').forEach((collapsible) => {
  const trigger = collapsible.querySelector('.icons-collapsible__trigger');
  const content = collapsible.querySelector('.icons-collapsible__content');

  function openContent() {
    content.style.maxHeight = content.scrollHeight + 'px';
    content.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeContent() {
    content.style.maxHeight = '0';
    content.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  // Initialise on load
  if (trigger.getAttribute('aria-expanded') === 'true') {
    openContent();
  } else {
    closeContent();
  }

  trigger.addEventListener('click', () => {
    if (trigger.getAttribute('aria-expanded') === 'true') {
      closeContent();
    } else {
      openContent();
    }
  });
});



  } catch(e) { console.error(e); }
})();
})();
